<script lang="ts">
  import SellSheetsIndex from "@distributor/svelte/SellSheet/Index.svelte";
  import Spinner from "@shared/svelte/Components/Spinner.svelte";
  import { HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";

  let sellSheetsRes;

  const load = async () => {
    const res = await HttpPromiseWithEntireResponse({
      method: "GET",
      url: "/api/distributor/sell_sheets",
      data: $params,
    });

    if (res.ok) {
      sellSheetsRes = await res.json();
      sellSheetsRes.headers = h => {
        return res.headers.get(h);
      };
    }
    return sellSheetsRes;
  };
</script>

{#await load()}
  <Spinner />
{:then sellSheetsRes}
  <SellSheetsIndex
    {sellSheetsRes}
    search={$params.search}
    page={$params.page}
    order={$params.order}
    direction={$params.direction}
  />
{/await}
